module.exports = __webpack_public_path__ + "img/zo-werkt-deze-bril.63d92140.svg";